/* PET · En páginas de políticas de Shopify, lleva el título de la política al pill
   del banner (donde por defecto dice "Políticas") y lo oculta del cuerpo (via CSS). */
(function () {
  function run() {
    var titleEl = document.querySelector('.shopify-policy__title');
    if (!titleEl) return; // no es una página de política
    var title = (titleEl.textContent || '').trim();
    if (!title) return;
    var pill = document.querySelector('.pet-catbanner__pill');
    if (pill) pill.textContent = title;
    var band = document.querySelector('.pet-catbanner__band');
    if (band) band.setAttribute('aria-label', title);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
